export const fetchBrokenDolls = async (query?: string | null, lastKey?: number | null) => {
  const url = 'https://6399kkay5c.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage/dolls';
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({ query: query?.toLowerCase(), lastKey })
  });
  const body = await response.json();
  return body.data;
};
